// extracted by mini-css-extract-plugin
export default {"container":"SegmentManagement_container__nBh3p"};